import { Button, Loading } from 'components'
import { authorizedRequest } from 'api'
import { useState } from 'react'
import { noop } from 'utils'

export type SnapshotBtnProps = {
  userId: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const SnapshotBtn = ({
  disabled = false,
  userId,
  onDone = noop,
  onError = noop,
}: SnapshotBtnProps) => {
  const [loading, setLoading] = useState<boolean>(false)

  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled || loading}
      onClick={async () => {
        setLoading(true)

        try {
          const endpoint = `snapshot/${userId}`
          const response = await authorizedRequest({
            endpoint,
            method: 'GET',
          })

          const json = await response.json()

          if (json.success) {
            setLoading(false)
            onDone(json.data)
          } else {
            throw new Error(json.error)
          }
        } catch (e: any) {
          setLoading(false)
          onError(e.message)
        }
      }}>
      {loading ? <Loading /> : <span>Data snapshot</span>}
    </Button>
  )
}
